import React, { Component } from 'react';

import {
  getIcon
} from '../../util/icons';

class InvalidAssessmentLink extends Component {

  state = {

  }

  render(){
    return (
      <div id="invalid-assessment-link" className="page">
        {getIcon('warning')}
        <h2>Invalid Assessment Link</h2>
        <h4>We cannot find any assessments with this link.</h4>
        <p>Please verify that you are using the correct link for accessing this assessment.</p>
      </div>
    )
  }
}

export default InvalidAssessmentLink;



// WEBPACK FOOTER //
// ./src/components/takeAssessment/invalidAssessmentLink.js